module.exports = __webpack_public_path__ + "img/vps_picture2.00721f1.png";